export const DEFAULT_OPUS_PACKAGE_CONFIG = {
  sampleRate: 48000,
  channels: 1,
  frameSize: 960, // 20ms at 48kHz (960 samples = 20ms)
  applicationVoip: 2048,
} as const;

export const CallWsEvent = {
  ConnectionReady: 'connection.ready',
  SessionJoin: 'session.join',
  AgentTranscript: 'agent.transcript',
  SessionReady: 'session.ready',
  SessionClose: 'session.close',

  Exception: 'exception',
} as const;
